let form = {
    labels: {
        title: 'Titre',
        description: 'Description',
        phone: 'Numéro de téléphone',
        email: 'Adresse email',
        address: 'Adresse',
        product: 'Produit',
        product_title: 'Titre',
        quantity: 'Quantité',
        price: 'Prix',
        price_type: 'Unité',
        price_per_unit: 'Prix unitaire',
        vat_option: 'TVA',
        total: 'Total',
        name: 'Nom',
        first_and_last_name: 'Nom et prénom',
        honorific: 'Civilité',
        phone_number: 'Numéro de téléphone',
        address_line_1: 'Adresse ligne 1',
        address_line_2: 'Adresse ligne 2',
        postal_code: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        comments: 'Commentaires',
        is_professional: 'Client professionnel',
        vat_number: 'Numéro de TVA',
        vat_option_id: 'TVA',
        default_vat_option_id: 'TVA par défaut',
        category_id: 'Catégorie',
        price_type_id: 'Unité',
        percentage: 'Pourcentage',
        payment_date: "Date d'échéance",
        payment_communication: "Instruction de paiement",
        valid_until: "Date de validité",
        paid_at: "Date du paiement",
        discount: "Remise",
        subject: "Sujet",
        email_subject: "Sujet de l'email",
        email_text: "Texte de l'email",
        email_to: "Destinataire",
        email_copy: "M'envoyer une copie par email",
        status: 'Statut',
        amount: 'Montant',

        company_name: "Nom de la société",
        company_email: "Addresse email",
        company_phone_number: "Numéro de téléphone",
        company_vat: "Numéro de TVA",
        company_vat_number: "Numéro de TVA",
        company_address_line_1: 'Adresse ligne 1',
        company_address_line_2: 'Adresse ligne 2',
        company_postal_code: 'Code postal',
        company_city: 'Ville',
        company_country: 'Pays',
        company_logo: 'Logo',

        client_id: 'Client',
        client_name: "Nom du client",
        client_email: "Addresse email",
        client_phone_number: "Numéro de téléphone",
        client_vat_number: "Numéro de TVA",
        client_address_line_1: 'Adresse ligne 1',
        client_address_line_2: 'Adresse ligne 2',
        client_postal_code: 'Code postal',
        client_city: 'Ville',
        client_country: 'Pays',
        client_reminder_1_enabled: 'Activer le premier niveau de rappel pour ce client',
        client_reminder_2_enabled: 'Activer le deuxième niveau de rappel pour ce client',
        client_reminder_3_enabled: 'Activer le troisième niveau de rappel pour ce client',
        
        invoice_title: 'Référence',
        invoice_files: 'Fichiers liés',
        invoice_number_prefix: 'Prefixe',
        invoice_number_prefix_custom: 'Prefixe personnalisé',
        current_year: 'Année',
        invoice_number_format: 'Format',
        invoice_number_demo: 'Exemple',
        invoice_number_starts_at: 'Début de la numérotation',
        invoice_number_starts_at_year: "Appliquer cette numérotation à l'année",
        invoice_number_starts_at_month: "Appliquer cette numérotation au mois",
        invoice_send_email_subject: "Sujet de l'email",
        invoice_send_email_text: "Texte de l'email",
        invoice_send_email_copy: "M'envoyer une copie par email",
        invoice_payment_delay: 'Delai de paiement par défaut',
        invoice_payment_delay_type: '',
        invoice_iban_number: 'IBAN',
        invoice_bic: 'BIC',
        invoice_payment_communication_type: 'Type de communication',
        invoice_number: 'Numéro de facture',
        structured_communication: 'Communication Structurée',
        invoice_payment_communication_type_custom: 'Communication personnalisée',
        invoice_payment_communication: 'Instruction de paiement par défaut',
        invoice_extra_pdf: 'PDF',
        invoice_display_custom_start: 'Modifier le début de la numérotation',

        quote_decline_reason: 'Raison de la déclinaison',
        quote_validity_delay: 'Délai de validité par défaut',
        quote_conditions: 'Conditions du devis',

        reminder_enabled: 'Activer ce niveau de rappel',
        reminder_value: "Jours après la date d'échéance",
        reminder_email_subject: "Sujet de l'email",
        reminder_email_text: "Texte de l'email",
        reminder_email_copy: "M'envoyer une copie de cet email",

        display_primary_color: 'Couleur principale',
        display_secondary_color: 'Couleur secondaire',

        card_number: 'Numéro de carte',
        card_expiry: "Date d'expiration",
        card_cvv: 'CVV',

        cocontractor: 'TVA Cocontractant',
        
        next_invoice_number: 'Numéro de la facture',
        next_quote_number: 'Numéro du devis',
        next_credit_note_number: 'Numéro de la note de credit',

        record_payment_predefined_title: 'Titre',
        record_payment_custom_title: 'Titre',

        invoice_template: 'Modèle de document',

        image_uploader_button: 'Déposez une image...',
        image_uploader_button_multiple: 'Déposez des images...',
        image_uploader_button_more: "Déposez une autre image...",
        image_uploader_button_more_multiple: "Déposez d'autres images...",
        image_uploader_button_replace: "Déposez pour remplacer l'image...",
        image_uploader_button_replace_multiple: "Déposez pour remplacer les images...",

        file_uploader_button: 'Déposez un fichier',
        file_uploader_button_multiple: 'Déposez des fichiers',
        file_uploader_button_selected: "Fichier sélectionné",
        file_uploader_button_selected_multiple: "Un fichier sélectionné | {count} fichiers sélectionnés",
        contacts: {
            title: "Contact",
            types: "Type de contact",
            name: "Nom du contact"
        }
    },
    placeholders: null,
    messages: {
        image_uploader_confirm_image_replacement: "Etes vous sûr de vouloir remplacer l'image actuelle?",
        image_uploader_wrong_image_type: "Le format du fichier n'est pas valide en tant qu'image."
    },
    buttons: {
        create: 'Créer',
        edit: 'Modifier'
    },
    variables: {
        invoicenumber: 'Numéro de la facture',
        quotenumber: 'Numéro du devis',
        creditnotenumber: 'Numéro de la note de crédit',
        communication: 'Communication',
        invoiceamount: 'Montant de la facture',
        quoteamount: 'Montant du devis',
        creditnoteamount: 'Montant de la note de crédit',
        invoiceremainingamount: 'Solde restant de la facture',
        creditnoteremainingamount: 'Solde restant de la note de crédit',
        iban: 'IBAN',
        bic: 'BIC',
        invoicedate: 'Date de la facture',
        quotedate: 'Date du devis',
        creditnotedate: 'Date de la note de crédit',
        duedate: "Date d'échéance",
        validitydate: "Date de validité",
        companyname: "Entreprise"
    },
    options: {
        invoice_number_prefix: {
            none: 'Aucun prefixe',
            custom: 'Prefixe personnalisé',
            year: 'Année en cours',
            year2: 'Année en cours (deux derniers chiffres)'
        },
        invoice_number_format: {
            1: 'Un chiffre',
            2: 'Deux chiffres',
            3: 'Trois chiffres',
            4: 'Quatre chiffres',
            5: 'Cinq chiffres'
        },
        invoice_number_starts_at_month: {
            none: 'Ne pas utiliser de début personnalisé par mois',
            1: 'Janvier',
            2: 'Février',
            3: 'Mars',
            4: 'Avril',
            5: 'Mai',
            6: 'Juin',
            7: 'Juillet',
            8: 'Aout',
            9: 'Septembre',
            10: 'Octobre',
            11: 'Novembre',
            12: 'Décembre',
        },
        invoice_payment_delay_type: {
            sent: "Jours date facture",
            month: "Jours fin de mois"
        },
        invoice_payment_communication_type: {
            invoice_number: 'Numéro de facture',
            structured_communication: 'Communication structurée',
            custom: 'Personnalisé',
        },
        quote_validity_delay_type: {
            sent: "Jours date devis",
        },
        record_payment_title: {
            total_payment: 'Paiement du solde',
            down_payment: 'Acompte',
            partial_payment: 'Paiement partiel',
            other: 'Autre'
        },
        invoice_template: {
            default: 'Classic',
            tiny: 'Tiny',
            condensed: 'Condensed',
            "flat-out": 'Flat out'
        }
    },
    helpers: {
        cocontractor: 'Fera apparaitre la mention "* Autoliquidation" sur les documents contenant un élément ou plus avec ce taux de TVA.'
    },
};

form.placeholders = form.labels;
form.placeholders.select = 'Choississez une option';

export default form;